import {
	DataSecurityWithAllFeaturesAndRanksTct,
	IncomeType,
} from '@dealstack/shared/lib/generated';
import {
	makeSecurityStateSnapshot,
	SecurityStateSnapshot,
} from '@dealstack/shared/lib/common/securities/securityFeatureRules';

/**
 * Adapts the security-details API payload to the shared rules snapshot. Keep this adapter thin:
 * snapshot semantics belong to makeSecurityStateSnapshot, which is also used by the backend.
 */
export const makeSecurityFeatureSnapshot = (
	security: DataSecurityWithAllFeaturesAndRanksTct
): SecurityStateSnapshot =>
	makeSecurityStateSnapshot({
		issuedIn: security.issuedIn,
		residueRights: security.residueRights,
		isExchangeTarget: !!security.exchangedFrom?.length,
		issuerHasNomineeStructure: security.issuerHasNomineeStructure,
		hasAuthorisedCapital: !!security.authorisedCapital,
		hasInterestDefinition: !!security.securityInterestDefinition,
		hasTracking: security.incomeType === IncomeType.TRACKING,
		hasRedemptionRights: !!security.securityRedemptionRights,
		hasCatchUpRights: !!security.securityCatchUpRights,
		hasExchangeRights: !!security.securityExchangeRights,
		hasLiquidationPreference: security.hasLiquidationPreference,
		hasParticipationThreshold: security.residueParticipationThreshold,
		hasRatcheting: !!security.securityRatchetSchedule,
	});
